import styled from '@emotion/styled'
import { CSSProperties, useEffect, useState } from 'react'
import { Colors } from 'src/components/theme'
import { rgbaStrOpacity } from 'src/utils/colors'
import { FANCY_SCROLLBAR, NESTED_FANCY_SCROLLBAR } from 'src/utils/styles'

const Container = styled.div<{ isNested?: 0 | 1 }>`
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: relative;
  ${({ isNested }) => (isNested ? NESTED_FANCY_SCROLLBAR : FANCY_SCROLLBAR)}

  .shadow-top {
    position: sticky;
    top: 0;
    height: 0;
    pointer-events: none;
    z-index: 1;
    transition: opacity 0.3s;

    ::after {
      z-index: 1;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 100%;
      background: linear-gradient(180deg, ${rgbaStrOpacity(Colors.neutral950, 0.07)}, transparent);
    }
  }

  .shadow-bottom {
    position: sticky;
    bottom: 0;
    height: 0;
    pointer-events: none;
    z-index: 1;
    transition: opacity 0.3s;
    ::after {
      z-index: 1;
      content: '';
      position: absolute;
      top: -24px;
      left: 0;
      height: 24px;
      width: 100%;
      background: linear-gradient(0deg, ${rgbaStrOpacity(Colors.neutral950, 0.2)}, transparent);
      border-bottom: 1px solid ${Colors.border};
    }
  }
`
export const ShadowScroll = (props: {
  children: React.ReactNode
  height?: CSSProperties['height']
  isNested?: boolean
  style?: CSSProperties
}) => {
  const { children, height, isNested, style } = props
  const [isAtTop, setIsAtTop] = useState(true)
  const [isAtBottom, setIsAtBottom] = useState(false)

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget

    setIsAtTop(scrollTop === 0)
    setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 1)
  }

  // when mounted check if at bottom
  useEffect(() => {
    const container = document.querySelector('.shadow-scroll')
    if (!container) {
      setIsAtBottom(true)
      return
    }
    const { scrollTop, scrollHeight, clientHeight } = container
    const isScrollable = scrollHeight > clientHeight
    setIsAtBottom(isScrollable ? scrollTop + clientHeight >= scrollHeight : false)
  }, [children])

  return (
    <Container
      isNested={isNested ? 1 : 0}
      className="shadow-scroll"
      style={{
        minHeight: height,
        height,
        maxHeight: height,
        ...style,
      }}
      onScroll={handleScroll}>
      <div
        style={{
          opacity: isAtTop ? 0 : 1,
        }}
        className="shadow-top"
      />
      {children}
      <div
        style={{
          opacity: isAtBottom ? 0 : 1,
        }}
        className="shadow-bottom"
      />
    </Container>
  )
}
